import React from "react";
import { IconBuildingCommunity, IconPlus, IconSearch } from "@tabler/icons-react";
import { LangConstant } from "const";
import { useTranslation } from "react-i18next";
import { debounce } from "lodash";

const UnitListHeader = ({ searchValue, handleSearchUnit, onOpenUnitDialog }) => {
  const { t: getLabel } = useTranslation([LangConstant.NS_COMMON, LangConstant.NS_LOGIN]);

  const handleOpenUnitDialog = () => {
    onOpenUnitDialog();
  };

  const handleDebounceSearchUnit = debounce(handleSearchUnit, 500);

  return (
    <div style={{ paddingBottom: 10, marginBottom: 20 }}>
      <div className="d-flex align-items-center pb-2 mb-3 border-bottom">
        <IconBuildingCommunity size={24} className="text-primary" />
        <h3 className="m-0 ms-3">{getLabel(LangConstant.TXT_TITLE_UNIT_LIST)}</h3>
      </div>
      <div className="d-flex align-items-center justify-content-between">
        <div className="input-group" style={{ width: 400 }}>
          <span className="input-group-text">
            <IconSearch size={16} />
          </span>
          <input
            type="text"
            className="form-control"
            defaultValue={searchValue}
            onChange={handleDebounceSearchUnit}
            placeholder={getLabel(LangConstant.P_SEARCH_UNIT)}
          />
        </div>
        <button className="btn btn-primary d-flex align-items-center gap-1" onClick={handleOpenUnitDialog}>
          <IconPlus size={16} />
          {getLabel(LangConstant.L_ADD_UNIT_BUTTON)}
        </button>
      </div>
    </div>
  );
};

export default UnitListHeader;
